module.exports = __webpack_public_path__ + "img/GR.7f084565.png";